
























































import { Vue, Component, Prop } from 'vue-property-decorator';
import Axios from 'axios';
import { CheckCheckoutTokenRequest } from '@/models/checkCheckoutTokenRequest';
import { CheckCheckoutTokenResponse } from '@/models/checkCheckoutTokenResponse';
import { UnivaPayCheckoutRequest } from '@/models/univaPayCheckoutRequest';
import { UnivaPayCheckoutResponse } from '@/models/univaPayCheckoutResponse';

@Component
export default class Checkout extends Vue {
  private loading = false;
  private message = '';

  private schoolName = '';
  private checkoutToken = '';
  private appToken = '';
  private title = '';
  private amount = 0;
  private currency = 'JPY';

  private async created() {
    this.loading = true;

    const token = this.$route.query.t as string;

    if (!token) {
      this.message = 'リクエストが不正です';
    } else {
      await this.loadData(token);
    }
    this.loading = false;
  }

  private deactivated() {
    this.$destroy();
  }

  private async loadData(token: string) {
    try {
      const request: CheckCheckoutTokenRequest = {
        token,
      };
      const res = await Axios.post<CheckCheckoutTokenResponse>('/api/link/checkout/check-token', request);
      const data = res.data;

      this.message = data.message;

      this.checkoutToken = data.token;
      this.appToken = data.appToken;
      this.schoolName = data.schoolName;
      this.title = data.title;
      this.amount = data.amount;
      this.currency = data.currency;

      this.loadUnivaPayButton();
    } catch (error) {
      this.message = 'リクエストが不正です';
      return;
    }
  }
  private loadUnivaPayButton() {
    this.$nextTick(async () => {
      const script: any = document.createElement('script');
      script.setAttribute(
        'src',
        'https://widget.univapay.com/client/checkout.js'
      );
      script.setAttribute('type', 'text/javascript');

      await this.loadScript(script);

      window.addEventListener('univapay:success', this.onSuccess, false);
    });
  }

  private loadScript(script: any): Promise<void> {
    const head = document.getElementsByTagName('head')[0];
    return new Promise((resolve) => {
      let done = false;
      script.onload = script.onreadystatechange = function() {
        if (!done && (!this.readyState || this.readyState === 'loaded' || this.readyState === 'complete')) {
          done = true;
          script.onload = script.onreadystatechange = null;
          head.removeChild( script );

          resolve();
        }
      };
      head.appendChild(script);
    });
  }

  private async onSuccess(e: any) {
    const ev: CustomEvent = e;

    try {
      const request: UnivaPayCheckoutRequest = {
        token: this.checkoutToken,
        transactionToken: ev.detail.tokenId,
      };
      const res = await Axios.post<UnivaPayCheckoutResponse>('/api/link/checkout', request);
      const data = res.data;

      this.message = data.message;
    } catch (error) {
      this.message = 'お支払いが失敗しました';
    }
  }
}
